var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "row employergroup-card"
  }, [_c('div', {
    staticClass: "employergroup-wrap"
  }, [_c('form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.searchEmployerGroup.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('input-text', {
    attrs: {
      "labelFor": "group_code",
      "labelName": "Group Name",
      "vmodel": _vm.filters.group_name,
      "formGroupClass": "col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4",
      "inputClass": "employergroupsearch-field"
    },
    on: {
      "update:vmodel": function updateVmodel($event) {
        return _vm.$set(_vm.filters, "group_name", $event);
      }
    }
  }), _c('input-text', {
    attrs: {
      "labelFor": "group_code",
      "labelName": "Group Code",
      "vmodel": _vm.filters.group_code,
      "formGroupClass": "col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4",
      "inputClass": "employergroupsearch-field"
    },
    on: {
      "update:vmodel": function updateVmodel($event) {
        return _vm.$set(_vm.filters, "group_code", $event);
      }
    }
  }), _c('input-text', {
    attrs: {
      "labelFor": "group_email",
      "labelName": "Email",
      "vmodel": _vm.filters.group_email,
      "formGroupClass": "col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4",
      "inputClass": "employergroupsearch-field"
    },
    on: {
      "update:vmodel": function updateVmodel($event) {
        return _vm.$set(_vm.filters, "group_email", $event);
      }
    }
  }), _c('input-multi-select', {
    attrs: {
      "labelFor": "status",
      "labelName": "Status",
      "inputName": "status",
      "vmodel": _vm.filters.status,
      "options": _vm.statuses.map(function (type) {
        return type.value;
      }),
      "custom-label": function customLabel(opt) {
        return _vm.statuses.find(function (x) {
          return x.value == opt;
        }).text;
      },
      "formGroupClass": "col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4",
      "placeholder": "Select Status"
    },
    on: {
      "update:vmodel": function updateVmodel($event) {
        return _vm.$set(_vm.filters, "status", $event);
      }
    }
  })], 1), _c('div', {
    staticClass: "form-group row"
  }, [_c('input-multi-select', {
    attrs: {
      "labelFor": "state",
      "labelName": "State",
      "inputName": "state",
      "vmodel": _vm.filters.state,
      "options": _vm.states.map(function (type) {
        return type.value;
      }),
      "custom-label": function customLabel(opt) {
        return _vm.states.find(function (x) {
          return x.value == opt;
        }).text;
      },
      "formGroupClass": "col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4",
      "placeholder": "Select State"
    },
    on: {
      "update:vmodel": function updateVmodel($event) {
        return _vm.$set(_vm.filters, "state", $event);
      }
    }
  }), _c('div', {
    staticClass: "col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4"
  }, [_c('label', [_vm._v("Enrollment Date")]), _c('div', {
    staticClass: "enrollmentDate-picker"
  }, [_c('date-picker', {
    attrs: {
      "input-class": "employergroupsearch-field",
      "placeholder": "From",
      "type": "date",
      "value-type": "format",
      "disabled-date": function disabledDate(date) {
        return _vm.disabledAfterCurrentDate(date, 'start');
      }
    },
    on: {
      "input": _vm.setToDate
    },
    model: {
      value: _vm.filters.signup_date_from,
      callback: function callback($$v) {
        _vm.$set(_vm.filters, "signup_date_from", $$v);
      },
      expression: "filters.signup_date_from"
    }
  }), _c('date-picker', {
    attrs: {
      "input-class": "employergroupsearch-field",
      "placeholder": "To",
      "type": "date",
      "value-type": "format",
      "disabled": _vm.disableDate,
      "disabled-date": function disabledDate(date) {
        return _vm.disabledAfterCurrentDate(date, 'end');
      }
    },
    model: {
      value: _vm.filters.signup_date_to,
      callback: function callback($$v) {
        _vm.$set(_vm.filters, "signup_date_to", $$v);
      },
      expression: "filters.signup_date_to"
    }
  })], 1)]), _c('input-multi-select', {
    attrs: {
      "labelFor": "industry",
      "labelName": "Industry",
      "inputName": "industry",
      "vmodel": _vm.filters.industry,
      "options": _vm.groupIndustries.map(function (type) {
        return type.value;
      }),
      "custom-label": function customLabel(opt) {
        return _vm.groupIndustries.find(function (x) {
          return x.value == opt;
        }).title;
      },
      "formGroupClass": "col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4",
      "placeholder": "Select Industry"
    },
    on: {
      "update:vmodel": function updateVmodel($event) {
        return _vm.$set(_vm.filters, "industry", $event);
      }
    }
  }), _c('div', {
    staticClass: "col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4"
  }, [_c('label', [_vm._v("View Downline Clients For")]), _c('multiselect', {
    attrs: {
      "name": "rep",
      "placeholder": "Select Rep",
      "options": _vm.reps.map(function (type) {
        return type.id;
      }),
      "custom-label": function customLabel(opt) {
        return _vm.reps.find(function (x) {
          return x.id == opt;
        }).first_name + ' ' + _vm.reps.find(function (x) {
          return x.id == opt;
        }).last_name;
      },
      "options-limit": 100,
      "internal-search": false,
      "local-search": false
    },
    on: {
      "search-change": _vm.searchHandler,
      "open": _vm.getReps
    },
    model: {
      value: _vm.filters.agent_id,
      callback: function callback($$v) {
        _vm.$set(_vm.filters, "agent_id", $$v);
      },
      expression: "filters.agent_id"
    }
  })], 1), _c('div', {
    staticClass: "col-xxl-3 col-xl-3 col-lg-6 col-md-6"
  }, [_c('label', [_vm._v("Employers & Groups")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filters.type,
      expression: "filters.type"
    }],
    staticClass: "form-select shadow-none",
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });

        _vm.$set(_vm.filters, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All")]), _c('option', {
    attrs: {
      "value": "direct"
    }
  }, [_vm._v("Direct")]), _c('option', {
    attrs: {
      "value": "downline"
    }
  }, [_vm._v("Downline")])])]), _c('div', {
    staticClass: "col-xxl-3 col-xl-3 col-lg-6 col-md-6"
  }, [_c('label', [_vm._v("Group Type")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filters.group_type,
      expression: "filters.group_type"
    }],
    staticClass: "form-select shadow-none",
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });

        _vm.$set(_vm.filters, "group_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All")]), _c('option', {
    attrs: {
      "value": "callcenter"
    }
  }, [_vm._v("Call Center")]), _c('option', {
    attrs: {
      "value": "employer"
    }
  }, [_vm._v("Employer")]), _c('option', {
    attrs: {
      "value": "agency"
    }
  }, [_vm._v("Agency")]), _c('option', {
    attrs: {
      "value": "group"
    }
  }, [_vm._v("Group")])])]), _c('div', {
    staticClass: "col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4"
  }, [_c('label', [_vm._v("Routing Number")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filters.routing_number,
      expression: "filters.routing_number"
    }],
    staticClass: "employergroupsearch-field",
    attrs: {
      "type": "text",
      "placeholder": "Routing Number",
      "maxlength": "9",
      "pattern": "\\d{9}"
    },
    domProps: {
      "value": _vm.filters.routing_number
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.filters, "routing_number", $event.target.value);
      }, function ($event) {
        _vm.filters.routing_number = _vm.filters.routing_number.replace(/\D/g, '').slice(0, 9);
      }]
    }
  }), _vm.filters.routing_number && _vm.filters.routing_number.length !== 9 ? _c('small', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" Please enter exactly 9 digits. ")]) : _vm._e()]), _c('div', {
    staticClass: "col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4"
  }, [_c('label', [_vm._v("Bank Account Number (Last 4 digits)")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filters.bank_account_last4,
      expression: "filters.bank_account_last4"
    }],
    staticClass: "employergroupsearch-field",
    attrs: {
      "type": "text",
      "placeholder": "Bank Account Number (Last 4 digits)",
      "maxlength": "4",
      "pattern": "\\d{4}"
    },
    domProps: {
      "value": _vm.filters.bank_account_last4
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.filters, "bank_account_last4", $event.target.value);
      }, function ($event) {
        _vm.filters.bank_account_last4 = _vm.filters.bank_account_last4.replace(/\D/g, '').slice(0, 4);
      }]
    }
  }), _vm.filters.bank_account_last4 && _vm.filters.bank_account_last4.length !== 4 ? _c('small', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" Please enter exactly 4 digits. ")]) : _vm._e()]), _c('div', {
    staticClass: "col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4"
  }, [_c('label', [_vm._v("Account Name")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filters.account_name,
      expression: "filters.account_name"
    }],
    staticClass: "employergroupsearch-field",
    attrs: {
      "type": "text",
      "placeholder": "Account Name"
    },
    domProps: {
      "value": _vm.filters.account_name
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.filters, "account_name", $event.target.value);
      }
    }
  })])], 1), _c('div', {
    staticClass: "row justify-content-md-end align-items-end"
  }, [_c('div', {
    staticClass: "col-12 col-xxl-auto col-xl-auto mb-3 mb-xl-0"
  }, [_c('div', {
    staticClass: "quick-date-btns d-flex align-items-center gap-2 flex-wrap"
  }, [_c('button', {
    staticClass: "quick-date-btn",
    class: {
      active: _vm.activeQuickFilter === 'all'
    },
    attrs: {
      "type": "button",
      "title": "All groups"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('quick-filter', 'all');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-list me-1"
  }), _vm._v(" All Groups ")]), _c('button', {
    staticClass: "quick-date-btn",
    class: {
      active: _vm.activeQuickFilter === 'today'
    },
    attrs: {
      "type": "button",
      "title": "Groups signed up today"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('quick-filter', 'today');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-calendar-day me-1"
  }), _vm._v(" Groups Today ")]), _c('button', {
    staticClass: "quick-date-btn",
    class: {
      active: _vm.activeQuickFilter === 'week'
    },
    attrs: {
      "type": "button",
      "title": "Groups signed up this week"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('quick-filter', 'week');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-calendar-week me-1"
  }), _vm._v(" Groups This Week ")]), _c('button', {
    staticClass: "quick-date-btn",
    class: {
      active: _vm.activeQuickFilter === 'month'
    },
    attrs: {
      "type": "button",
      "title": "Groups signed up this month"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('quick-filter', 'month');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-calendar-alt me-1"
  }), _vm._v(" Groups This Month ")])])]), _vm._m(0), _c('div', {
    staticClass: "col-xxl-2 col-xl-3"
  }, [_c('button', {
    staticClass: "univ-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.exportGroup
    }
  }, [_c('i', {
    staticClass: "fas fa-file-export",
    staticStyle: {
      "margin-right": "5px"
    }
  }), _vm._v(" Export")])]), _c('div', {
    staticClass: "col-xxl-2 col-xl-3"
  }, [_c('button', {
    staticClass: "univ-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openLogModal
    }
  }, [_c('img', {
    staticClass: "rep-logs-icon",
    attrs: {
      "src": require("@/assets/images/rep-logs.svg"),
      "width": "20px",
      "alt": "Switch Logs Icon"
    }
  }), _c('span', [_vm._v("Switch Logs")])])])])])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-xxl-2 col-xl-3"
  }, [_c('button', {
    staticClass: "univ-btn",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Search")])]);
}]

export { render, staticRenderFns }